/**
 * Palette der 3D-Figur. Die SVG-Figur ist die Referenz (Plan
 * `2026-10-02-mat-3d-website`, Design 8 und 9): Jeder Wert, den die SVG
 * ebenfalls zeichnet, steht hier mit ihrem Wert, und `palette.spec.tsx`
 * vergleicht beide Seiten am gerenderten SVG. Weicht die 3D ab, aendert sich
 * die 3D — nie die SVG.
 *
 * Die SVG-Figur liest ihre Farben ebenfalls hier: `MatFigure.tsx` (Kontur,
 * Visier, Huelle, Glow, Schatten), `MatTeaserBadge.tsx` (`KI_ACCENT`,
 * `KI_SURFACE`), `mat-head.tsx` (Augen, Kabel), `mat-avatar.tsx`. Die
 * uebrigen Werte hat nur die 3D-Figur (Labor `lab/core.js`, Objekt `C`).
 *
 * Die Datei liegt im Theme-Verzeichnis, weil WebGL keine CSS-Variablen liest:
 * Three.js braucht den Farbwert selbst. Sie ist die eine Quelle der Mat-Farben
 * fuer SVG und 3D; `validate:theme-colors` prueft die Verbraucher.
 */
export const MAT_PALETTE = {
    /** Huelle, Kopf und Hand (SVG `#F7F5FA`). */
    shell: "#F7F5FA",
    shellAlt: "#EDE7F4",
    /** Kontur onDark, Augen, Antennenball (SVG `stroke` onDark, `KI_ACCENT`). */
    mint: "#8ce6d1",
    /** Visier onDark (SVG `visor` onDark, `KI_SURFACE`). */
    visor: "#1f0e36",
    /** Visier onLight (SVG `visor` onLight). */
    purple: "#3c1d64",
    /** Kontur onLight (SVG `stroke` onLight). */
    purpleMid: "#67309f",
    lilac: "#a24cdb",
    /** Antennenkabel (SVG `mat-head.tsx`). */
    red: "#e2452f",
    brass: "#d6b06a",
    /** Quatico-Wortmarke, Brustzeichen `superq-purple`. */
    logo: "#602f92",
    /** Augenglanz, Glanzlicht, Schluessel- und Fuelllicht der 3D. */
    white: "#ffffff",
    /** Innerer Glow-Verlauf (SVG `MatFigure`). */
    glow: "#a8f0e0",
    /** Bodenschatten onDark (SVG `MatFigure`). */
    shadowOnDark: "#000000",
    /** Metallteile der 3D. */
    metal: "#e3c27c",
    /** Glasteile der 3D. */
    glass: "#f3ecff",
    /** Dunkle Teile der 3D (Rolle `dark`). */
    dark: "#1a0c2c",
    /** Himmels- und Bodenfarbe des Hemisphaerenlichts der 3D. */
    hemiLight: "#f7ecfe",
    /** Lila Kantenlicht der 3D. */
    rimLilac: "#c58cff",
} as const;

export type MatPaletteKey = keyof typeof MAT_PALETTE;
